<template>
    <UiCoreDynamicComponents
        v-editable="blok"
        class="sb-core-dynamic-components"
        data-test="sb-core-dynamic-components"
        :blok="blok"
    />
</template>

<script setup lang="ts">
import type { ICoreDynamicComponents } from '@nuxt-monorepo/ui/types/components/CoreDynamicComponents';

defineProps<{ blok: ICoreDynamicComponents }>();
</script>

<style scoped lang="postcss"></style>
